export default __webpack_public_path__ + "static/media/textimg.e2dcc1ea.png";